<template>
  <main class="collection-page" :class="{'game-bg' : portalGeneralInfo.hasCollectionBackground }">
    <div class="mt-3">
      <div class="mx-auto d-flex text-center flex-column justify-content-center
                  bg-white collection-carousel-item"
           >
           <i :class="['collection-icon', `i-${collection.icon} ${portalGeneralInfo.Skin}`]"/>
      </div>
        <h6 class="text-center mt-2">
          {{ collection.name }}
        </h6>
    </div>
      <article class="mt-4">
      <ProductListWithoutCarousel :products="collectionProducts" />
    </article>
  </main>
</template>

<script>
import ProductListWithoutCarousel from '@/components/ProductListWithoutCarousel.vue'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'GameCollectionDetailBlueTheme',
  components: {
    ProductListWithoutCarousel
  },
  data() {
    return {
      bottomOfWindow: false,
      isLoading: false
    }
  },
  props: {
    collection: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    ...mapGetters({
      fileUrl: 'cdn/fileUrl',
      portalConfigurations: 'tenantDesign/config'
    }),
    collectionProducts() {
      return this.collection.products.map(value => {
        return {
          title: value.name,
          imageUrl: value.icon,
          publisher: value.publisher ? value.publisher.name : '',
          targetUrl: '/product/' + value.id,
          id: value.id,
          genre: value.genres
            .map(g => {
              return g.name
            })
            .join(', ')
        }
      })
    },
    portalGeneralInfo () {
      return this.portalConfigurations.general
    }
  },
  mounted() {
    window.addEventListener("scroll", this.onScroll);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.onScroll);
  },
  methods: {
    ...mapActions({
      loadCollectionProducts: 'productCatalog/loadCollectionProducts'
    }),
    loadMore() {
      this.isLoading = true
      this.loadCollectionProducts(this.collection.id)
      this.bottomOfWindow =
        document.documentElement.scrollTop + window.innerHeight ===
        document.documentElement.offsetHeight
      window.onscroll = () => {
        if (this.bottomOfWindow) {
          this.$ga.event('Game', 'GamesListShowMore')
          this.loadCollectionProducts(this.collection.id)
          this.isLoading = false
          }
      }
    },
    onScroll(e) {

      this.bottomOfWindow =
        (e.target.documentElement.scrollTop + window.innerHeight) ===
        document.documentElement.offsetHeight
        if (this.bottomOfWindow) {
          this.$ga.event('Game', 'GamesListShowMore')
          this.loadCollectionProducts(this.collection.id)
          this.isLoading = false
        }
    }
  }
}
</script>
